// Generated by Melange

import * as Caml_module from "melange.js/caml_module.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";

const Imported$pmodules = {};

const Buhta = Caml_module.init_mod([
      "proto/identapis/gen/buhta_ident_identification_v1alpha1_ident_provider_state.ml",
      115,
      6
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            {
                              TAG: /* Module */0,
                              _0: [
                                [
                                  /* Function */0,
                                  "name"
                                ],
                                [
                                  /* Function */0,
                                  "to_int"
                                ],
                                [
                                  /* Function */0,
                                  "from_int"
                                ],
                                [
                                  /* Function */0,
                                  "from_int_exn"
                                ],
                                [
                                  /* Function */0,
                                  "to_string"
                                ],
                                [
                                  /* Function */0,
                                  "from_string_exn"
                                ]
                              ]
                            },
                            "VerifyIdCardScanState"
                          ],
                          [
                            {
                              TAG: /* Module */0,
                              _0: [
                                [
                                  /* Function */0,
                                  "name"
                                ],
                                [
                                  /* Function */0,
                                  "to_int"
                                ],
                                [
                                  /* Function */0,
                                  "from_int"
                                ],
                                [
                                  /* Function */0,
                                  "from_int_exn"
                                ],
                                [
                                  /* Function */0,
                                  "to_string"
                                ],
                                [
                                  /* Function */0,
                                  "from_string_exn"
                                ]
                              ]
                            },
                            "VerifyLivenessState"
                          ],
                          [
                            {
                              TAG: /* Module */0,
                              _0: [
                                [
                                  /* Function */0,
                                  "name"
                                ],
                                [
                                  /* Function */0,
                                  "to_int"
                                ],
                                [
                                  /* Function */0,
                                  "from_int"
                                ],
                                [
                                  /* Function */0,
                                  "from_int_exn"
                                ],
                                [
                                  /* Function */0,
                                  "to_string"
                                ],
                                [
                                  /* Function */0,
                                  "from_string_exn"
                                ]
                              ]
                            },
                            "VerifyCoidState"
                          ]
                        ]
                      },
                      "V1alpha1"
                    ]]
                },
                "Identification"
              ]]
          },
          "Ident"
        ]]
    });

const Ident = Caml_module.init_mod([
      "proto/identapis/gen/buhta_ident_identification_v1alpha1_ident_provider_state.ml",
      195,
      8
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "to_int"
                          ],
                          [
                            /* Function */0,
                            "from_int"
                          ],
                          [
                            /* Function */0,
                            "from_int_exn"
                          ],
                          [
                            /* Function */0,
                            "to_string"
                          ],
                          [
                            /* Function */0,
                            "from_string_exn"
                          ]
                        ]
                      },
                      "VerifyIdCardScanState"
                    ],
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "to_int"
                          ],
                          [
                            /* Function */0,
                            "from_int"
                          ],
                          [
                            /* Function */0,
                            "from_int_exn"
                          ],
                          [
                            /* Function */0,
                            "to_string"
                          ],
                          [
                            /* Function */0,
                            "from_string_exn"
                          ]
                        ]
                      },
                      "VerifyLivenessState"
                    ],
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "to_int"
                          ],
                          [
                            /* Function */0,
                            "from_int"
                          ],
                          [
                            /* Function */0,
                            "from_int_exn"
                          ],
                          [
                            /* Function */0,
                            "to_string"
                          ],
                          [
                            /* Function */0,
                            "from_string_exn"
                          ]
                        ]
                      },
                      "VerifyCoidState"
                    ]
                  ]
                },
                "V1alpha1"
              ]]
          },
          "Identification"
        ]]
    });

const Identification = Caml_module.init_mod([
      "proto/identapis/gen/buhta_ident_identification_v1alpha1_ident_provider_state.ml",
      273,
      10
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "to_int"
                    ],
                    [
                      /* Function */0,
                      "from_int"
                    ],
                    [
                      /* Function */0,
                      "from_int_exn"
                    ],
                    [
                      /* Function */0,
                      "to_string"
                    ],
                    [
                      /* Function */0,
                      "from_string_exn"
                    ]
                  ]
                },
                "VerifyIdCardScanState"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "to_int"
                    ],
                    [
                      /* Function */0,
                      "from_int"
                    ],
                    [
                      /* Function */0,
                      "from_int_exn"
                    ],
                    [
                      /* Function */0,
                      "to_string"
                    ],
                    [
                      /* Function */0,
                      "from_string_exn"
                    ]
                  ]
                },
                "VerifyLivenessState"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "to_int"
                    ],
                    [
                      /* Function */0,
                      "from_int"
                    ],
                    [
                      /* Function */0,
                      "from_int_exn"
                    ],
                    [
                      /* Function */0,
                      "to_string"
                    ],
                    [
                      /* Function */0,
                      "from_string_exn"
                    ]
                  ]
                },
                "VerifyCoidState"
              ]
            ]
          },
          "V1alpha1"
        ]]
    });

const V1alpha1 = Caml_module.init_mod([
      "proto/identapis/gen/buhta_ident_identification_v1alpha1_ident_provider_state.ml",
      349,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "to_int"
              ],
              [
                /* Function */0,
                "from_int"
              ],
              [
                /* Function */0,
                "from_int_exn"
              ],
              [
                /* Function */0,
                "to_string"
              ],
              [
                /* Function */0,
                "from_string_exn"
              ]
            ]
          },
          "VerifyIdCardScanState"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "to_int"
              ],
              [
                /* Function */0,
                "from_int"
              ],
              [
                /* Function */0,
                "from_int_exn"
              ],
              [
                /* Function */0,
                "to_string"
              ],
              [
                /* Function */0,
                "from_string_exn"
              ]
            ]
          },
          "VerifyLivenessState"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "to_int"
              ],
              [
                /* Function */0,
                "from_int"
              ],
              [
                /* Function */0,
                "from_int_exn"
              ],
              [
                /* Function */0,
                "to_string"
              ],
              [
                /* Function */0,
                "from_string_exn"
              ]
            ]
          },
          "VerifyCoidState"
        ]
      ]
    });

const VerifyIdCardScanState = Caml_module.init_mod([
      "proto/identapis/gen/buhta_ident_identification_v1alpha1_ident_provider_state.ml",
      370,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "to_int"
        ],
        [
          /* Function */0,
          "from_int"
        ],
        [
          /* Function */0,
          "from_int_exn"
        ],
        [
          /* Function */0,
          "to_string"
        ],
        [
          /* Function */0,
          "from_string_exn"
        ]
      ]
    });

const VerifyLivenessState = Caml_module.init_mod([
      "proto/identapis/gen/buhta_ident_identification_v1alpha1_ident_provider_state.ml",
      438,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "to_int"
        ],
        [
          /* Function */0,
          "from_int"
        ],
        [
          /* Function */0,
          "from_int_exn"
        ],
        [
          /* Function */0,
          "to_string"
        ],
        [
          /* Function */0,
          "from_string_exn"
        ]
      ]
    });

const VerifyCoidState = Caml_module.init_mod([
      "proto/identapis/gen/buhta_ident_identification_v1alpha1_ident_provider_state.ml",
      510,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "to_int"
        ],
        [
          /* Function */0,
          "from_int"
        ],
        [
          /* Function */0,
          "from_int_exn"
        ],
        [
          /* Function */0,
          "to_string"
        ],
        [
          /* Function */0,
          "from_string_exn"
        ]
      ]
    });

function name(param) {
  return ".buhta.ident.identification.v1alpha1.VerifyIdCardScanState";
}

function to_int(param) {
  switch (param) {
    case /* VERIFY_ID_CARD_SCAN_STATE_UNSPECIFIED */0 :
        return 0;
    case /* VERIFY_ID_CARD_SCAN_STATE_PENDING */1 :
        return 10;
    case /* VERIFY_ID_CARD_SCAN_STATE_PROCESSING */2 :
        return 20;
    case /* VERIFY_ID_CARD_SCAN_STATE_COMPLETE */3 :
        return 30;
    
  }
}

function from_int_exn(n) {
  if (n >= 11) {
    if (n !== 20) {
      if (n !== 30) {
        return Ocaml_protoc_plugin__Result.raise({
                    NAME: "Unknown_enum_value",
                    VAL: n
                  });
      } else {
        return /* VERIFY_ID_CARD_SCAN_STATE_COMPLETE */3;
      }
    } else {
      return /* VERIFY_ID_CARD_SCAN_STATE_PROCESSING */2;
    }
  } else if (n !== 0) {
    if (n >= 10) {
      return /* VERIFY_ID_CARD_SCAN_STATE_PENDING */1;
    } else {
      return Ocaml_protoc_plugin__Result.raise({
                  NAME: "Unknown_enum_value",
                  VAL: n
                });
    }
  } else {
    return /* VERIFY_ID_CARD_SCAN_STATE_UNSPECIFIED */0;
  }
}

function from_int(e) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return from_int_exn(e);
            });
}

function to_string(param) {
  switch (param) {
    case /* VERIFY_ID_CARD_SCAN_STATE_UNSPECIFIED */0 :
        return "VERIFY_ID_CARD_SCAN_STATE_UNSPECIFIED";
    case /* VERIFY_ID_CARD_SCAN_STATE_PENDING */1 :
        return "VERIFY_ID_CARD_SCAN_STATE_PENDING";
    case /* VERIFY_ID_CARD_SCAN_STATE_PROCESSING */2 :
        return "VERIFY_ID_CARD_SCAN_STATE_PROCESSING";
    case /* VERIFY_ID_CARD_SCAN_STATE_COMPLETE */3 :
        return "VERIFY_ID_CARD_SCAN_STATE_COMPLETE";
    
  }
}

function from_string_exn(s) {
  switch (s) {
    case "VERIFY_ID_CARD_SCAN_STATE_COMPLETE" :
        return /* VERIFY_ID_CARD_SCAN_STATE_COMPLETE */3;
    case "VERIFY_ID_CARD_SCAN_STATE_PENDING" :
        return /* VERIFY_ID_CARD_SCAN_STATE_PENDING */1;
    case "VERIFY_ID_CARD_SCAN_STATE_PROCESSING" :
        return /* VERIFY_ID_CARD_SCAN_STATE_PROCESSING */2;
    case "VERIFY_ID_CARD_SCAN_STATE_UNSPECIFIED" :
        return /* VERIFY_ID_CARD_SCAN_STATE_UNSPECIFIED */0;
    default:
      return Ocaml_protoc_plugin__Result.raise({
                  NAME: "Unknown_enum_name",
                  VAL: s
                });
  }
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "to_int"
        ],
        [
          /* Function */0,
          "from_int"
        ],
        [
          /* Function */0,
          "from_int_exn"
        ],
        [
          /* Function */0,
          "to_string"
        ],
        [
          /* Function */0,
          "from_string_exn"
        ]
      ]
    }, VerifyIdCardScanState, {
      name: name,
      to_int: to_int,
      from_int: from_int,
      from_int_exn: from_int_exn,
      to_string: to_string,
      from_string_exn: from_string_exn
    });

function name$1(param) {
  return ".buhta.ident.identification.v1alpha1.VerifyLivenessState";
}

function to_int$1(param) {
  switch (param) {
    case /* VERIFY_LIVENESS_STATE_UNSPECIFIED */0 :
        return 0;
    case /* VERIFY_LIVENESS_STATE_PENDING_CHECK */1 :
        return 10;
    case /* VERIFY_LIVENESS_STATE_PROCESSING_CHECK */2 :
        return 20;
    case /* VERIFY_LIVENESS_STATE_PENDING_MATCH */3 :
        return 30;
    case /* VERIFY_LIVENESS_STATE_COMPLETE */4 :
        return 40;
    
  }
}

function from_int_exn$1(n) {
  if (n >= 20) {
    if (n !== 30) {
      if (n !== 40) {
        if (n >= 21) {
          return Ocaml_protoc_plugin__Result.raise({
                      NAME: "Unknown_enum_value",
                      VAL: n
                    });
        } else {
          return /* VERIFY_LIVENESS_STATE_PROCESSING_CHECK */2;
        }
      } else {
        return /* VERIFY_LIVENESS_STATE_COMPLETE */4;
      }
    } else {
      return /* VERIFY_LIVENESS_STATE_PENDING_MATCH */3;
    }
  } else if (n !== 0) {
    if (n !== 10) {
      return Ocaml_protoc_plugin__Result.raise({
                  NAME: "Unknown_enum_value",
                  VAL: n
                });
    } else {
      return /* VERIFY_LIVENESS_STATE_PENDING_CHECK */1;
    }
  } else {
    return /* VERIFY_LIVENESS_STATE_UNSPECIFIED */0;
  }
}

function from_int$1(e) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return from_int_exn$1(e);
            });
}

function to_string$1(param) {
  switch (param) {
    case /* VERIFY_LIVENESS_STATE_UNSPECIFIED */0 :
        return "VERIFY_LIVENESS_STATE_UNSPECIFIED";
    case /* VERIFY_LIVENESS_STATE_PENDING_CHECK */1 :
        return "VERIFY_LIVENESS_STATE_PENDING_CHECK";
    case /* VERIFY_LIVENESS_STATE_PROCESSING_CHECK */2 :
        return "VERIFY_LIVENESS_STATE_PROCESSING_CHECK";
    case /* VERIFY_LIVENESS_STATE_PENDING_MATCH */3 :
        return "VERIFY_LIVENESS_STATE_PENDING_MATCH";
    case /* VERIFY_LIVENESS_STATE_COMPLETE */4 :
        return "VERIFY_LIVENESS_STATE_COMPLETE";
    
  }
}

function from_string_exn$1(s) {
  switch (s) {
    case "VERIFY_LIVENESS_STATE_COMPLETE" :
        return /* VERIFY_LIVENESS_STATE_COMPLETE */4;
    case "VERIFY_LIVENESS_STATE_PENDING_CHECK" :
        return /* VERIFY_LIVENESS_STATE_PENDING_CHECK */1;
    case "VERIFY_LIVENESS_STATE_PENDING_MATCH" :
        return /* VERIFY_LIVENESS_STATE_PENDING_MATCH */3;
    case "VERIFY_LIVENESS_STATE_PROCESSING_CHECK" :
        return /* VERIFY_LIVENESS_STATE_PROCESSING_CHECK */2;
    case "VERIFY_LIVENESS_STATE_UNSPECIFIED" :
        return /* VERIFY_LIVENESS_STATE_UNSPECIFIED */0;
    default:
      return Ocaml_protoc_plugin__Result.raise({
                  NAME: "Unknown_enum_name",
                  VAL: s
                });
  }
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "to_int"
        ],
        [
          /* Function */0,
          "from_int"
        ],
        [
          /* Function */0,
          "from_int_exn"
        ],
        [
          /* Function */0,
          "to_string"
        ],
        [
          /* Function */0,
          "from_string_exn"
        ]
      ]
    }, VerifyLivenessState, {
      name: name$1,
      to_int: to_int$1,
      from_int: from_int$1,
      from_int_exn: from_int_exn$1,
      to_string: to_string$1,
      from_string_exn: from_string_exn$1
    });

function name$2(param) {
  return ".buhta.ident.identification.v1alpha1.VerifyCoidState";
}

function to_int$2(param) {
  switch (param) {
    case /* VERIFY_COID_STATE_UNSPECIFIED */0 :
        return 0;
    case /* VERIFY_COID_STATE_PENDING_MATCH */1 :
        return 10;
    case /* VERIFY_COID_STATE_PROCESSING_MATCH */2 :
        return 20;
    case /* VERIFY_COID_STATE_COMPLETE */3 :
        return 30;
    
  }
}

function from_int_exn$2(n) {
  if (n >= 11) {
    if (n !== 20) {
      if (n !== 30) {
        return Ocaml_protoc_plugin__Result.raise({
                    NAME: "Unknown_enum_value",
                    VAL: n
                  });
      } else {
        return /* VERIFY_COID_STATE_COMPLETE */3;
      }
    } else {
      return /* VERIFY_COID_STATE_PROCESSING_MATCH */2;
    }
  } else if (n !== 0) {
    if (n >= 10) {
      return /* VERIFY_COID_STATE_PENDING_MATCH */1;
    } else {
      return Ocaml_protoc_plugin__Result.raise({
                  NAME: "Unknown_enum_value",
                  VAL: n
                });
    }
  } else {
    return /* VERIFY_COID_STATE_UNSPECIFIED */0;
  }
}

function from_int$2(e) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return from_int_exn$2(e);
            });
}

function to_string$2(param) {
  switch (param) {
    case /* VERIFY_COID_STATE_UNSPECIFIED */0 :
        return "VERIFY_COID_STATE_UNSPECIFIED";
    case /* VERIFY_COID_STATE_PENDING_MATCH */1 :
        return "VERIFY_COID_STATE_PENDING_MATCH";
    case /* VERIFY_COID_STATE_PROCESSING_MATCH */2 :
        return "VERIFY_COID_STATE_PROCESSING_MATCH";
    case /* VERIFY_COID_STATE_COMPLETE */3 :
        return "VERIFY_COID_STATE_COMPLETE";
    
  }
}

function from_string_exn$2(s) {
  switch (s) {
    case "VERIFY_COID_STATE_COMPLETE" :
        return /* VERIFY_COID_STATE_COMPLETE */3;
    case "VERIFY_COID_STATE_PENDING_MATCH" :
        return /* VERIFY_COID_STATE_PENDING_MATCH */1;
    case "VERIFY_COID_STATE_PROCESSING_MATCH" :
        return /* VERIFY_COID_STATE_PROCESSING_MATCH */2;
    case "VERIFY_COID_STATE_UNSPECIFIED" :
        return /* VERIFY_COID_STATE_UNSPECIFIED */0;
    default:
      return Ocaml_protoc_plugin__Result.raise({
                  NAME: "Unknown_enum_name",
                  VAL: s
                });
  }
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "to_int"
        ],
        [
          /* Function */0,
          "from_int"
        ],
        [
          /* Function */0,
          "from_int_exn"
        ],
        [
          /* Function */0,
          "to_string"
        ],
        [
          /* Function */0,
          "from_string_exn"
        ]
      ]
    }, VerifyCoidState, {
      name: name$2,
      to_int: to_int$2,
      from_int: from_int$2,
      from_int_exn: from_int_exn$2,
      to_string: to_string$2,
      from_string_exn: from_string_exn$2
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "to_int"
              ],
              [
                /* Function */0,
                "from_int"
              ],
              [
                /* Function */0,
                "from_int_exn"
              ],
              [
                /* Function */0,
                "to_string"
              ],
              [
                /* Function */0,
                "from_string_exn"
              ]
            ]
          },
          "VerifyIdCardScanState"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "to_int"
              ],
              [
                /* Function */0,
                "from_int"
              ],
              [
                /* Function */0,
                "from_int_exn"
              ],
              [
                /* Function */0,
                "to_string"
              ],
              [
                /* Function */0,
                "from_string_exn"
              ]
            ]
          },
          "VerifyLivenessState"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "to_int"
              ],
              [
                /* Function */0,
                "from_int"
              ],
              [
                /* Function */0,
                "from_int_exn"
              ],
              [
                /* Function */0,
                "to_string"
              ],
              [
                /* Function */0,
                "from_string_exn"
              ]
            ]
          },
          "VerifyCoidState"
        ]
      ]
    }, V1alpha1, {
      VerifyIdCardScanState: VerifyIdCardScanState,
      VerifyLivenessState: VerifyLivenessState,
      VerifyCoidState: VerifyCoidState
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "to_int"
                    ],
                    [
                      /* Function */0,
                      "from_int"
                    ],
                    [
                      /* Function */0,
                      "from_int_exn"
                    ],
                    [
                      /* Function */0,
                      "to_string"
                    ],
                    [
                      /* Function */0,
                      "from_string_exn"
                    ]
                  ]
                },
                "VerifyIdCardScanState"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "to_int"
                    ],
                    [
                      /* Function */0,
                      "from_int"
                    ],
                    [
                      /* Function */0,
                      "from_int_exn"
                    ],
                    [
                      /* Function */0,
                      "to_string"
                    ],
                    [
                      /* Function */0,
                      "from_string_exn"
                    ]
                  ]
                },
                "VerifyLivenessState"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "to_int"
                    ],
                    [
                      /* Function */0,
                      "from_int"
                    ],
                    [
                      /* Function */0,
                      "from_int_exn"
                    ],
                    [
                      /* Function */0,
                      "to_string"
                    ],
                    [
                      /* Function */0,
                      "from_string_exn"
                    ]
                  ]
                },
                "VerifyCoidState"
              ]
            ]
          },
          "V1alpha1"
        ]]
    }, Identification, {
      V1alpha1: V1alpha1
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "to_int"
                          ],
                          [
                            /* Function */0,
                            "from_int"
                          ],
                          [
                            /* Function */0,
                            "from_int_exn"
                          ],
                          [
                            /* Function */0,
                            "to_string"
                          ],
                          [
                            /* Function */0,
                            "from_string_exn"
                          ]
                        ]
                      },
                      "VerifyIdCardScanState"
                    ],
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "to_int"
                          ],
                          [
                            /* Function */0,
                            "from_int"
                          ],
                          [
                            /* Function */0,
                            "from_int_exn"
                          ],
                          [
                            /* Function */0,
                            "to_string"
                          ],
                          [
                            /* Function */0,
                            "from_string_exn"
                          ]
                        ]
                      },
                      "VerifyLivenessState"
                    ],
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "to_int"
                          ],
                          [
                            /* Function */0,
                            "from_int"
                          ],
                          [
                            /* Function */0,
                            "from_int_exn"
                          ],
                          [
                            /* Function */0,
                            "to_string"
                          ],
                          [
                            /* Function */0,
                            "from_string_exn"
                          ]
                        ]
                      },
                      "VerifyCoidState"
                    ]
                  ]
                },
                "V1alpha1"
              ]]
          },
          "Identification"
        ]]
    }, Ident, {
      Identification: Identification
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            {
                              TAG: /* Module */0,
                              _0: [
                                [
                                  /* Function */0,
                                  "name"
                                ],
                                [
                                  /* Function */0,
                                  "to_int"
                                ],
                                [
                                  /* Function */0,
                                  "from_int"
                                ],
                                [
                                  /* Function */0,
                                  "from_int_exn"
                                ],
                                [
                                  /* Function */0,
                                  "to_string"
                                ],
                                [
                                  /* Function */0,
                                  "from_string_exn"
                                ]
                              ]
                            },
                            "VerifyIdCardScanState"
                          ],
                          [
                            {
                              TAG: /* Module */0,
                              _0: [
                                [
                                  /* Function */0,
                                  "name"
                                ],
                                [
                                  /* Function */0,
                                  "to_int"
                                ],
                                [
                                  /* Function */0,
                                  "from_int"
                                ],
                                [
                                  /* Function */0,
                                  "from_int_exn"
                                ],
                                [
                                  /* Function */0,
                                  "to_string"
                                ],
                                [
                                  /* Function */0,
                                  "from_string_exn"
                                ]
                              ]
                            },
                            "VerifyLivenessState"
                          ],
                          [
                            {
                              TAG: /* Module */0,
                              _0: [
                                [
                                  /* Function */0,
                                  "name"
                                ],
                                [
                                  /* Function */0,
                                  "to_int"
                                ],
                                [
                                  /* Function */0,
                                  "from_int"
                                ],
                                [
                                  /* Function */0,
                                  "from_int_exn"
                                ],
                                [
                                  /* Function */0,
                                  "to_string"
                                ],
                                [
                                  /* Function */0,
                                  "from_string_exn"
                                ]
                              ]
                            },
                            "VerifyCoidState"
                          ]
                        ]
                      },
                      "V1alpha1"
                    ]]
                },
                "Identification"
              ]]
          },
          "Ident"
        ]]
    }, Buhta, {
      Ident: Ident
    });

export {
  Imported$pmodules ,
  Buhta ,
}
/* Buhta Not a pure module */
